<template>
  <div class="filterCategory">
      <Loader v-if="loader == true" />
      <div
         v-else 
         class="filterCategory__flex"
        >
          <button @click="filterMobView = true" class="view_filter_mob">
              <span class="mdi mdi-filter"></span> Фильтр
          </button>
          <div class="filterCategory__left">
              <div class="filter__brend">
                    <input type="text" placeholder="Поиск по товарам" :readonly="is_read" @focus="focus_read"  v-model="searchProduct">
                    <div class="filter_brend_title">
                        <h4>
                            Цена
                        </h4>
                    </div>
                    <div class="filter_range">
                        <input 
                            type="range" 
                            :min="minPriceStatic" 
                            :max="maxPriceStatic"
                            step="0"
                            v-model.number="minPrice"
                            @change="setRangeSliders"
                        >
                        <input 
                            type="range" 
                            :min="minPriceStatic"  
                            :max="maxPriceStatic"
                            step="0"
                            v-model.number="maxPrice"
                            @change="setRangeSliders"
                        >
                    </div>
                    <div class="filter_range_values">
                        <p>{{minPrice}} ₸</p>
                        <p>{{maxPrice}} ₸</p>
                    </div>
                    <div class="filter_brend_title">
                        <h4>
                            Бренд
                        </h4>
                    </div>
                    <v-container class="filter_checkbox_block" fluid>
                        <v-checkbox 
                            v-for="brend in brends"
                            :key="brend.id" 
                            color="#680"
                            v-model="selected" 
                            :label="brend.name" 
                            :value="brend.name"
                            hide-details="true"
                            @change="filter_products"
                        ></v-checkbox>
                    </v-container>
              </div>
          </div>
          <div 
            class="filterCategory__right"
           >
                <div class="not__category__product" v-if="pagginateProducts.length == 0">
                    <p>
                        Нечего не найдено
                    </p>
                </div>
                <CategoryProduct 
                    v-for="category in pagginateProducts"
                    :key="category.id" 
                    v-bind:id="category.id" 
                    v-bind:img="category.img[0]" 
                    v-bind:title="category.title" 
                    v-bind:price="category.price"
                    v-bind:description="category.description" 
                    v-bind:remain="category.remain" 
                />
                
                <div v-show="paginations_produts_view">
                    <paginate
                        :page-count="pages"
                        :click-handler="pageSlide"
                        :prev-text="'Назад'"
                        :next-text="'Вперед'"
                        :container-class="'pagination'"
                        :next-class="'page-item-next'"
                        :prev-class="'page-item-prev'"
                        :active-class="'page-item-active'"
                        :page-class="'page-item'">
                    </paginate>
                </div>
          </div>

          <div v-show="filterMobView" class="view_fliter_menu">
            <h3>
                фильтр по категориям
            </h3>
            <div class="filter__brend">
                    <button @click="filterMobView = false" class="get_filter">
                        применить фильтр
                    </button>
                    <div class="filter_brend_title">
                        <h4>
                            Цена
                        </h4>
                    </div>
                    <div class="filter_range">
                        <input 
                            type="range" 
                            :min="minPriceStatic" 
                            :max="maxPriceStatic"
                            step="0"
                            v-model.number="minPrice"
                            @change="setRangeSliders"
                        >
                        <input 
                            type="range" 
                            :min="minPriceStatic"  
                            :max="maxPriceStatic"
                            step="0"
                            v-model.number="maxPrice"
                            @change="setRangeSliders"
                        >
                    </div>
                    <div class="filter_range_values">
                        <p>{{minPrice}} ₸</p>
                        <p>{{maxPrice}} ₸</p>
                    </div>
                    <div class="filter_brend_title">
                        <h4>
                            Бренд
                        </h4>
                    </div>
                    <v-container class="filter_checkbox_block" fluid>
                        <v-checkbox 
                            v-for="brend in brends"
                            :key="brend.id" 
                            color="#680"
                            v-model="selected" 
                            :label="brend.name" 
                            :value="brend.name"
                            hide-details="true"
                            @change="filter_products"
                        ></v-checkbox>
                    </v-container>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import CategoryProduct from '@/components/CategoryProduct'
import Loader from '@/components/Loader'

export default {
  name: 'filterCategory',
  components: {
      CategoryProduct, Loader
  },
  data () {
      return {
        selected: [],
        category_id: [],
        brends: [],
        searchProduct: null,
        filterResult: [],
        productsPages: 5,
        pageNumber: 1,
        paginations_produts_view: true,
        minPrice: 0,
        maxPrice: 15000,
        minPriceStatic: 0,
        maxPriceStatic: 15000,
        loader: true,
        filterMobView: false,
        is_read: true,
      }
  },
  methods: {
    getCategoryId () {
        this.loader = true
        fetch(this.$apiURI + 'public/category/assoc/get?data={"category_id": "' + this.$route.params.id + '"}')
        .then((res) => {
            res.json().then((data) => {
                this.category_id = data
                this.filterResult = this.category_id
                let max = data.reduce((prev, cur) => {
                    if (prev.price > cur.price) {
                        return prev
                    }
                    return cur
                })
                let min = data.reduce((prev, cur) => {
                    if (prev.price < cur.price) {
                        return prev
                    }
                    return cur
                })
                this.minPriceStatic = min.price
                this.maxPriceStatic = max.price
                this.minPrice = min.price
                this.maxPrice = max.price
                this.loader = false
            });
        })
    },
    getBrends() {
        fetch(this.$apiURI + 'public/filter/get?data={"category_id": "' + this.$route.params.id + '"}')
        .then((res) => {
            res.json().then((data) => {
                this.brends = data
            });
        })
    },
    filter_products() {
        this.pageNumber = 1
        if(this.selected.length == 0) {
            this.paginations_produts_view = true
            return this.filterResult = this.category_id
        }
        else {
            let res = this.category_id.filter(item => {
                if (this.selected.length > 0) {
                        if (item.brand_name == null) {
                            return false
                        } else {
                            return this.selected.indexOf(item.brand_name[0]) > -1;
                        }
                }
                return item;
            });
            this.paginations_produts_view = false
            return this.filterResult = res
        }
    },
    pageSlide(page) {
        this.pageNumber = page
    },
    setRangeSliders() {
        if (this.minPrice > this.maxPrice) {
            let tmp = this.maxPrice
            this.maxPrice = this.minPrice;
            this.minPrice = tmp
        }
        let vm = this; 
        this.filterResult = this.category_id.filter((item) => {
            return item.price >= vm.minPrice && item.price <= vm.maxPrice
        })
    },
    pagginateProducts_ST() {
        this.paginations_produts_view = true
        let from = (this.pageNumber - 1) * this.productsPages;
        let to = from + this.productsPages;
        return this.filterResult.slice(from, to)
    },
    focus_read() {
          this.is_read = false
    }
  },
  mounted() {
    this.getCategoryId()
    this.getBrends()
  },
  created() {
    this.$upd.$on('updatefiltercategory', () => {
        this.getCategoryId()
        this.getBrends()
    })
  },
  computed: { 
    pages() {
        return Math.ceil(this.filterResult.length / this.productsPages)
    },
    pagginateProducts() {
        if(this.searchProduct) {
            return this.filterResult.filter((item)=>{
                this.paginations_produts_view = false
                return this.searchProduct.toLowerCase().split(' ').every(v => item.title.toLowerCase().includes(v))
            })
        } else {
            return this.pagginateProducts_ST()
        }
    }
  }
}
</script>
<style lang="less">
@baseMedia: 900px;
.filterCategory {
    width: 1200px;
    margin: 0 auto;
    background: white;
    @media (max-width: @baseMedia) {
        width: 100%;
    }
    .filterCategory__flex {
        width: 100%;
        display: flex;
        justify-content: space-between;
        @media (max-width: @baseMedia) {
            justify-content: center;
            flex-wrap: wrap;
        }
        .view_fliter_menu {
            width: 100%;
            height: 100%;
            position: fixed;
            z-index: 999999;
            background: white;
            overflow-y: scroll;
            top: 0;
            text-align: center;
            h3 {
                margin-top: 10px;
                margin-bottom: 10px;
                text-transform: uppercase;
                color: #5c6041;
            }
            .filter__brend {
                width: 95%;
                margin: 0 auto;
                .get_filter {
                    width: 100%;
                    height: 40px;
                    background: #0a9;
                    color: white;
                    border: none;
                    margin-bottom: 10px;
                    font-weight: bold;
                    text-transform: uppercase;
                    &:hover {
                        background: #02675d;
                    }
                }
                .filter_checkbox_block {
                    margin-top: 10px;
                    margin-bottom: 20px;
                }
                .filter_brend_title {
                    width: 100%;
                    background: #668800;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    text-align: center;
                    h4 {
                        color: #fff;
                        font-size: 15px;
                        text-transform: uppercase;
                    }
                }
                .container--fluid {
                    padding: 0;
                }
                input {
                    width: 100%;
                    height: 33px;
                    border: 2px solid #668800;
                    text-align: center;
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
                .filter_range {
                    width: 100%;
                    position: relative;
                    margin-top: 10px;
                    input[type="range"] {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 5px;
                        outline: none;
                        -webkit-appearance: none;
                        background: #d3d3d3;
                        &::-webkit-slider-thumb {
                            z-index: 2;
                            position: relative;
                            -webkit-appearance: none;
                            width: 10px;
                            height: 25px;
                            background:#fff;
                            border: 1px solid #668800;
                            cursor: pointer;
                            &:hover {
                                background: #f5f5f5;
                            }
                        }
                    }
                }
                .filter_range_values {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 40px;
                    margin-bottom: 10px;
                    p {
                        font-weight: bold;
                        color: #5c6041;
                    }
                }
            }
        }
        .v-input--selection-controls {
            margin-top: 0;
        }
        .view_filter_mob {
            width: 100%;
            padding-top: 10px;
            padding-bottom: 10px;
            background: #a9c40c;
            margin-top: 10px;
            text-align: center;
            display: none;
            text-transform: uppercase;
            font-weight: bold;
            @media (max-width: @baseMedia) {
                display: block;
            }
            cursor: pointer;
            color: white;
            &:hover {
                background: #668800;
            }
        }
        .filterCategory__left {
            width: 18%;
            border-right: 1px solid #ccc;
            text-align: center;
            @media (max-width: @baseMedia) {
                display: none;
            }
            .filter__brend {
                width: 95%;
                margin: 0 auto;
                .filter_checkbox_block {
                    margin-top: 10px;
                    margin-bottom: 20px;
                }
                .filter_brend_title {
                    width: 100%;
                    background: #668800;
                    padding-top: 10px;
                    padding-bottom: 10px;
                    h4 {
                        color: #fff;
                        font-size: 15px;
                        text-transform: uppercase;
                    }
                }
                .container--fluid {
                    padding: 0;
                }
                input {
                    width: 100%;
                    height: 33px;
                    border: 2px solid #668800;
                    text-align: center;
                    margin-top: 10px;
                    margin-bottom: 10px;
                }
                .filter_range {
                    width: 100%;
                    position: relative;
                    margin-top: 10px;
                    input[type="range"] {
                        position: absolute;
                        top: 0;
                        left: 0;
                        height: 5px;
                        outline: none;
                        -webkit-appearance: none;
                        background: #d3d3d3;
                        &::-webkit-slider-thumb {
                            z-index: 2;
                            position: relative;
                            -webkit-appearance: none;
                            width: 10px;
                            height: 25px;
                            background:#fff;
                            border: 1px solid #668800;
                            cursor: pointer;
                            &:hover {
                                background: #f5f5f5;
                            }
                        }
                    }
                }
                .filter_range_values {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 40px;
                    margin-bottom: 10px;
                    p {
                        font-weight: bold;
                        color: #5c6041;
                    }
                }
            }
        }
        .filterCategory__right {
            width: 80%;
            margin-right: 10px; 
            @media (max-width: @baseMedia) {
                width: 95%;
                margin-right: 0px;
                margin: 0 auto;
            }
            .pagination {
                list-style: none;
                display: flex;
                justify-content: flex-end;
                align-items: center;
                margin-bottom: 20px;
            }
            .page-item {
                background: #494948;
                padding: 4px 9px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                margin: 1px;
                border-radius: 2px;
                user-select: none;
            }
            .page-item-next {
                background: #494948;
                color: #fff;
                padding: 4px;
                border-radius: 2px;
            }
            .page-item-prev {
                background: #494948;
                color: #fff;
                padding: 4px;
                border-radius: 2px;
            }
            .page-item-active {
                background: #1b1b19;
            }
            .not__category__product {
                width: 100%;
                height: 100px;
                display: flex;
                justify-content: center;
                align-items: center;
                p {
                    font-size: 25px;
                }
            }
        }
    }
}
</style>